// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsGoalsAddTemplate_heading__pDq1c","buttonLink":"ReportingDetailsGoalsAddTemplate_buttonLink__MwV4D"};